import React, { ChangeEventHandler, FocusEventHandler } from "react";

import { useFormData } from "@sp-state/useFormData";
import IconsWrapper from "./IconsWrapper";
import InputWrapper from "../InputWrapper";
import OtherProfessionsInput from "../OtherProfessionsInput";

import styles from "./ProfessionsInput.module.scss";
import { useSpecialties } from "@hooks/useSpecialties";

const ProfessionsInput = () => {
  const { specialties } = useSpecialties(0);

  const { profession, setError, setValue, setIsValid } = useFormData(
    state => state
  );
  const isOther = profession.value === "7";

  const onBlur: FocusEventHandler<HTMLSelectElement> = e => {
    if (e.target.value.trim() === "") {
      setError("profession", true);
      setIsValid("profession", false);
    }
  };

  const onChange: ChangeEventHandler<HTMLSelectElement> = e => {
    const { value } = e.target;
    setValue("profession", value);

    if (profession.hasError) setError("profession", false);

    if (value === "7") {
      setIsValid("profession", false);
      return;
    }

    if (value.trim() !== "") {
      setIsValid("profession", true);
      setIsValid("otherProfession", false);
      setValue("otherProfession", "");
    }
  };

  const specialtiesList =
    specialties &&
    specialties.map(option => (
      <option key={option.label} value={option.value}>
        {option.label}
      </option>
    ));

  return (
    <>
      <InputWrapper
        errorMsg="This field is required."
        hasError={profession.hasError}
        label="What best describes your practice?"
      >
        <div className={styles.selectField}>
          <select
            className={`${styles.field} ${profession.hasError && styles.error}`}
            onBlur={onBlur}
            onChange={onChange}
            value={profession.value || ""}
          >
            <option value="" disabled>
              Select one
            </option>

            {specialtiesList}
          </select>

          <IconsWrapper
            hasError={profession.hasError}
            isOther={isOther}
            isValid={profession.isValid}
          />
        </div>
      </InputWrapper>
      <OtherProfessionsInput />
    </>
  );
};

export default ProfessionsInput;
